import React, { useState, useEffect, useMemo } from 'react';
import { Button, ButtonGroup, Col, Row, Card } from 'react-bootstrap';
import { Header, Segment, Image, Dimmer, Loader, Icon } from 'semantic-ui-react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from "react-router-dom";
import Amplify, { API, Auth } from 'aws-amplify';
import { Typography as ATypography } from 'antd';

const useStyles = makeStyles(() => ({
    root: {
        alignItems: 'center',
        lineHeight: '24px',
        width: '100.00%',
        height: '100.00%',
        position: 'relative',
        display: 'flex',
        '& .cellValue': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
}));

function isOverflown(element) {
    return (
        element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth
    );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
    const { width, value } = props;
    const wrapper = React.useRef(null);
    const cellDiv = React.useRef(null);
    const cellValue = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const classes = useStyles();
    const [showFullCell, setShowFullCell] = React.useState(false);
    const [showPopper, setShowPopper] = React.useState(false);

    const handleMouseEnter = () => {
        const isCurrentlyOverflown = isOverflown(cellValue.current);
        setShowPopper(isCurrentlyOverflown);
        setAnchorEl(cellDiv.current);
        setShowFullCell(true);
    };

    const handleMouseLeave = () => {
        setShowFullCell(false);
    };

    React.useEffect(() => {
        if (!showFullCell) {
            return undefined;
        }

        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
                setShowFullCell(false);
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowFullCell, showFullCell]);

    return (
        <div
            ref={wrapper}
            className={classes.root}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                ref={cellDiv}
                style={{
                    height: 1,
                    width,
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                }}
            />
            <div ref={cellValue} className="cellValue">
                {value}
            </div>
            {showPopper && (
                <Popper
                    open={showFullCell && anchorEl !== null}
                    anchorEl={anchorEl}
                    style={{ width, marginLeft: -17 }}
                >
                    <Paper
                        elevation={1}
                        style={{ minHeight: wrapper.current.offsetHeight - 3 }}
                    >
                        <Typography variant="body2" style={{ padding: 8, wordWrap: "break-word" }}>
                            {value}
                        </Typography>
                    </Paper>
                </Popper>
            )}
        </div>
    );
});

GridCellExpand.propTypes = {
    value: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
};

function renderCellExpand(params) {
    return (
        <GridCellExpand
            value={params.value ? params.value.toString() : ''}
            width={params.colDef.width}
        />
    );
}

renderCellExpand.propTypes = {
    /**
     * The column of the row that the current cell belongs to.
     */
    colDef: PropTypes.any.isRequired,
    /**
     * The cell value, but if the column has valueGetter, use getValue.
     */
    value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
        PropTypes.bool,
    ]),
};

export default function ESP_Detail() {

    const Bucket = "https://p450-result-prod.s3.amazonaws.com/";
    // const Bucket = "https://ugtdb-tib-prod-s3tibprodugtdb5094d93f-1rmju6fmzr79j.s3.amazonaws.com/";
    const { id } = useParams();

    const [items, setItems] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    const columns = [
        {
            field: 'id',
            headerName: 'Enzyme',
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: 'Sequence',
            headerName: 'Sequence',
            flex: 3,
            renderCell: renderCellExpand,
        },
        {
            field: 'Score',
            headerName: 'Score',
            flex: 1,
            renderCell: renderCellExpand,
        }
    ];


    async function postRequest(props) {
        // Amplify.Logger.LOG_LEVEL = "DEBUG";
        const session = await Auth.currentCredentials();
        // console.log(session)
        const apiRequest = {
            body: {
                "ids": props,

            },
            headers: {
                "Content-Type": "application/json",
                // "Authorization":  session.getIdToken().getJwtToken()
            },
        };

        return await API
            .post("Substrate", "/api/result", apiRequest)
            .then(
                (data) => {
                    console.log(data);
                    readCSV(data.data[0].result);
                    // setIsLoaded(true);
                    // setTimeout(() => {
                    //   setIsLoaded(true);
                    // }, 1000)

                },
                (error) => {
                    console.log(error);
                    setIsLoaded(true);
                }
            );
    };

    function readCSV(props) {
        fetch(Bucket + props)
            .then(res => res.text())
            .then(result => {
                setItems(processItems(result));
                setTimeout(() => {
                    setIsLoaded(true);
                }, 500);
            })
    }

    function processItems(params) {
        var currentItems = [];
        let array = params.replaceAll("\r,", "").split("\n");
        for (let i = 1; i < array.length - 1; i++) {
            let currentArr = array[i].split(",");
            let currentItem = {
                "id": currentArr[0],
                "Enzyme": currentArr[0],
                "Sequence": currentArr[1],
                "Score": currentArr[2]
            }
            currentItems.push(currentItem)
        }
        return currentItems;
    }

    useEffect(() => {
        if (id !== null) {
            let current = [];
            current.push(id)
            postRequest(current);
        } else {
            window.location.href = "/esp-results"
        }
    }, [])

    return (
        <div style={{
            background: "#FFFFFF"
        }}>

            <Row>
                <Col >
                </Col>
                <Col md={10}>

                    <div style={{

                        height: "50px"
                    }}>
                    </div>
                    <div>


                        <Card>
                            <Card.Header>
                                <Header textAlign='center'>
                                    <span style={{ color: "#6495ED" }} >Enzyme-Substrate Interaction Predictor Detail</span>
                                </Header>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ margin: "25px 75px 25px 75px" }}>
                                    <ATypography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Users can submit a substrate molecule (in SDF format) along with one or more P450 sequences. We will use a deep learning model (Seq-P450: <ATypography.Link href='https://github.com/JiangLab2020/Seq-P450' target='_blank' rel='noopener noreferrer'>https://github.com/JiangLab2020/Seq-P450</ATypography.Link>) to predict the likelihood that these P450 enzymes can catalyze the submitted substrate molecule.</blockquote></ATypography.Paragraph>
                                </div>
                                <Segment basic >
                                    {
                                        isLoaded
                                            ?
                                            <DataGrid
                                                rows={items}
                                                columns={columns}
                                                autoHeight
                                                pageSize={10}
                                                // rowsPerPageOptions={[10, 25, 50, 100]}
                                                // pagination
                                                components={{
                                                    Toolbar: GridToolbar,
                                                }}
                                            />
                                            :
                                            <Segment>
                                                <Dimmer active inverted>
                                                    <Loader size='medium'>Loading</Loader>
                                                </Dimmer>

                                                <Image src='../paragraph.png' />
                                            </Segment>
                                    }
                                </Segment>


                            </Card.Body>
                        </Card>


                    </div>


                    <div>


                        <div>

                        </div>



                    </div>
                    <div style={{

                        height: "50px"
                    }}>
                    </div>
                </Col>
                <Col >
                </Col>
            </Row>
        </div>

    );
}